export class OpcionesPerfilRolDto {

  opcionesPerfilRolDto?: object;

  constructor(init?: Partial<OpcionesPerfilRolDto>) {
    if (init) {
      Object.assign(this, init);
    }
  }
}
